import { Component, inject } from '@angular/core';
import { CareersRoutingService } from '../core/routing/careers-routing.service';
import { Router } from '@angular/router';
import { DashboardComponent } from '../dashboard/dashboard/dashboard.component';

@Component({
  selector: 'sca-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  imports: [DashboardComponent]
})
export class HomeComponent {
  private _careersRoutingService = inject(CareersRoutingService);
  private _routerService = inject(Router);

  public canViewDashboard: boolean = false;

  constructor() {
    const defaultURL: string = this._careersRoutingService.getCurrentUserDefaultAppRouteURL();
    if (defaultURL === '' || defaultURL === '/home') {
      this.canViewDashboard = true;
      return;
    }

    this._routerService.navigateByUrl(defaultURL);
  }
}
